import { Pill } from './Pill';
import { PillButton } from './PillButton';
import { ValueButton, ValueButtonProps } from './ValueButton';
import { OperatorButton, OperatorButtonProps } from './OperatorButton';
import { FilterPillLabel, FilterPillLabelProps } from './FilterPillLabel';
import { CloseFilterPillIcon } from './CloseFilterPillIcon';
import { BackgroundColor, FlexBox } from '@ardoq/layout';
import { ReactNode } from 'react';
import { TruncatedTextPopover } from '@ardoq/popovers';

type ReadonlyOperatorButtonProps = {
  type: 'readonly';
} & ReadOnlyPillSegmentProps;

type FilterPillOperatorButtonProps =
  | OperatorButtonProps
  | ReadonlyOperatorButtonProps;

export type TableFilterPillViewProps = {
  label: FilterPillLabelProps;
  operator: FilterPillOperatorButtonProps;
  value: ValueButtonProps | string | null;
  onRemove: VoidFunction;
  removeFilterAriaLabel?: string;
};

export const TableFilterPillView = (props: TableFilterPillViewProps) => (
  <Pill>
    <FilterPillLabel {...props.label} />
    {props.operator.type === 'readonly' ? (
      <ReadOnlyPillSegment
        shouldGrow={false}
        {...props.operator}
        backgroundColor="surfaceDefaultSubtle"
      />
    ) : (
      <OperatorButton {...props.operator} />
    )}
    {props.value === null ? null : typeof props.value === 'string' ? (
      <ReadOnlyPillSegment backgroundColor="surfaceDefault" shouldGrow>
        <TruncatedTextPopover>{props.value}</TruncatedTextPopover>
      </ReadOnlyPillSegment>
    ) : (
      <ValueButton {...props.value} />
    )}
    <PillButton
      $isActive={false}
      onClick={props.onRemove}
      aria-label={props.removeFilterAriaLabel ?? 'Remove filter'}
    >
      <CloseFilterPillIcon />
    </PillButton>
  </Pill>
);

type ReadOnlyPillSegmentProps = {
  children: ReactNode;
};

type ReadOnlyPillSegmentWithStylingProps = ReadOnlyPillSegmentProps & {
  backgroundColor: BackgroundColor;
  shouldGrow: boolean;
};

const ReadOnlyPillSegment = ({
  backgroundColor,
  shouldGrow = false,
  children,
}: ReadOnlyPillSegmentWithStylingProps) => (
  <FlexBox
    paddingY="xsmall"
    paddingX="small"
    align="center"
    height="full"
    backgroundColor={backgroundColor}
    flexGrow={shouldGrow ? 1 : 0}
    flexShrink={shouldGrow ? 1 : 0}
    minWidth={shouldGrow ? '0' : undefined}
  >
    {children}
  </FlexBox>
);
